/**
 * @file A no-op function.
 */

/**
 * Does nothing.
 *
 * @returns {undefined}
 */
const noop = () => {};

export default noop;
